import axios from 'axios'
import {
  clearRequestsAuthToken,
  getRequestsAuthToken,
  isRequestsApiUrl
} from './requestsAuth'

let isConfigured = false
let currentUserData = null

export const setAxiosUserContext = (userData) => {
  currentUserData = userData || null
}

export const setupAxiosRequestsAuth = () => {
  if (isConfigured) {
    return
  }

  isConfigured = true

  axios.interceptors.request.use(
    async (config) => {
      const headers = {
        ...config.headers,
        ...(currentUserData && {
          'user-id': JSON.stringify({
            userId: currentUserData?.id,
            email: currentUserData?.email
          })
        }),
        'Accept-Language': 'es-ES,es;'
      }

      if (isRequestsApiUrl(config.url)) {
        const token = await getRequestsAuthToken()
        delete headers.authorization
        headers.Authorization = `Bearer ${token}`
      }

      config.headers = headers

      return config
    },
    (error) => Promise.reject(error)
  )

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (
        [401, 403].includes(error?.response?.status) &&
        isRequestsApiUrl(error?.config?.url) &&
        !error?.config?._requestsAuthRetry
      ) {
        clearRequestsAuthToken()

        const retryConfig = {
          ...error.config,
          _requestsAuthRetry: true,
          headers: {
            ...error.config.headers
          }
        }

        delete retryConfig.headers.Authorization

        return axios(retryConfig)
      }

      return Promise.reject(error)
    }
  )
}
